import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './redux'
import { GlobalStyle } from './style/GlobalStyle'
import Fonts from './assets/fonts/fonts'
import { BrowserRouter as Router } from 'react-router-dom'

ReactDOM.render(

  <React.StrictMode>
    <Router>
      <Provider store={store}>
        <Fonts />
        <GlobalStyle />
        <App />
      </Provider>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

